export interface InvoiceVehicleFields {
  vehicle_year?: number | string | null;
  vehicle_make?: string | null;
  vehicle_model?: string | null;
  vehicle_color?: string | null;
  vehicle_vin?: string | null;
  vehicle_license_plate?: string | null;
  vehicle?: {
    year?: number | string | null;
    make?: string | null;
    model?: string | null;
    color?: string | null;
    vin?: string | null;
    license_plate?: string | null;
  } | null;
}

function trimValue(value: unknown): string | null {
  if (value == null) return null;
  const trimmed = String(value).trim();
  return trimmed || null;
}

export function formatInvoiceVehicleDisplay(service: InvoiceVehicleFields): string | null {
  const year = trimValue(service.vehicle_year ?? service.vehicle?.year);
  const make = trimValue(service.vehicle_make ?? service.vehicle?.make);
  const model = trimValue(service.vehicle_model ?? service.vehicle?.model);
  const color = trimValue(service.vehicle_color ?? service.vehicle?.color);
  const vin = trimValue(service.vehicle_vin ?? service.vehicle?.vin);
  const licensePlate = trimValue(service.vehicle_license_plate ?? service.vehicle?.license_plate);

  const primary = [year, make, model].filter(Boolean).join(' ').trim();
  if (!primary && !color && !vin && !licensePlate) return null;

  const parts: string[] = [];
  if (primary) parts.push(primary);
  if (color) parts.push(color);
  if (vin) parts.push(`VIN: ${vin}`);
  if (licensePlate) parts.push(`Plate: ${licensePlate}`);

  return parts.join(' · ');
}

export function hasInvoiceVehicle(service: InvoiceVehicleFields): boolean {
  return formatInvoiceVehicleDisplay(service) !== null;
}
